import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router";
import IconeUser from "../assets/icons/user-svgrepo.svg";
import { jwtDecode } from "jwt-decode";
import keyIcon from "../assets/IconeSvg/key-square.svg";
import iconeDeconnexion from "../assets/IconeSvg/logout.svg";
// import logo from "../assets/Images/imageLogo_bgRev.png";
import logo from "../assets/Images/imageLogo_bgRev.bc43c66dc5538ccb39e2.png";

import { FaChartBar, FaUsers } from "react-icons/fa";
import { AiFillProduct } from "react-icons/ai";
import { IoSettings } from "react-icons/io5";
import { RiAdminFill } from "react-icons/ri";

const NavBarBackOffice = () => {
  const navigate = useNavigate();
  const [connectedUser, setConnectedUser] = useState([]);

  // useEffect(() => {
  //   const token = localStorage.getItem("compte_admin");
  //   const decoded = token ? jwtDecode(token) : null;

  //   setConnectedUser(decoded)
  // }, []);

  // console.log("Connected infos :", connectedUser )

  const deconnectAdmin = () => {
    localStorage.removeItem("compte_admin");
    navigate("/");
  };

  useEffect(() => {
    const token = localStorage.getItem("compte_admin");
    const decoded = token ? jwtDecode(token) : null;

    setConnectedUser(decoded);
  }, []);

  return (
    <div className="navbar bg-base-100 shadow-sm">
      <div className="navbar-start">
        <div className="dropdown">
          <div tabIndex={0} role="button" className="btn btn-ghost p-[0.5rem] lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {" "}
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />{" "}
            </svg>
          </div>
          <ul className="menu menu-sm dropdown-content bg-base-100 rounded-box z-1 mt-3 w-40 gap-2 p-2 shadow">
            <li>
              <NavLink to={"/dashboard"} className="gap-x-2">
                <FaChartBar />
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink to={"/produits"} className="gap-x-2">
                <AiFillProduct />
                <span>Produits</span>
              </NavLink>
            </li>
            <li>
              <NavLink to={"/comptesClients"} className="gap-x-2">
                <FaUsers />
                <span>Comptes clients</span>
              </NavLink>
            </li>
            <li>
              <NavLink to={"/parametrages"} className="gap-x-2" >
                <IoSettings />
                <span>Parametrages</span>
              </NavLink>
            </li>
            <li>
              <NavLink to={"/admins"} className="gap-x-2">
                <RiAdminFill />
                <span>Administrateurs</span>
              </NavLink>
            </li>
          </ul>
        </div>
        <button className="flex items-center justify-center  ">
          <NavLink to={"/"} className="text-lg font-semibold italic">
            <img src={logo} alt="" className="w-24" />
          </NavLink>
        </button>
      </div>

      <div className="navbar-end">
        <div className="flex dropdown dropdown-hover  px-8">
          <div tabIndex={0} role="button" className=" m-1">
            <button className="flex flex-row justify-start items-center">
              <img src={IconeUser} alt="" className="w-6" />
              <div className=" flex flex-col justify-start items-start pl-2">
                <span className="text-sm font-normal text-black">
                  Bienvenue
                </span>
                <h1 className="text-[12px] text-black font-bold text-start ">
                  {connectedUser?.name}
                </h1>
              </div>
            </button>
          </div>
          <ul
            tabIndex={0}
            className="dropdown-content menu bg-base-100 rounded-xl top-12 right-1  z-[1] w-52 mx-auto p-2 shadow border"
          >
            <button
              className="w-full mx-auto h-11 bg-gray-100 text-sm text-black font-semibold flex items-center gap-x-2 px-4 rounded-xl"
              onClick={() => {
                document.getElementById("update-password").showModal();
              }}
            >
              <img src={keyIcon} className="w-6" />
              <span>Mot de passe</span>
            </button>
            <button
              className="mt-2 w-full mx-auto h-11 bg-black text-sm text-white font-semibold flex items-center gap-x-2 px-4 rounded-xl"
              onClick={() => deconnectAdmin()}
            >
              <img src={iconeDeconnexion} className="w-6" />
              <span>Déconnexion</span>
            </button>
          </ul>
        </div>

        <button
          onClick={() => document.getElementById("my_modal_2").showModal()}
          className=" lg:hidden md:hidden  flex-row justify-start items-center"
        ></button>
      </div>
    </div>
  );
};

export default NavBarBackOffice;
